module.exports = __webpack_public_path__ + "img/TF1_logo_2013.5dda9689.png";